import { InvalidEmailError } from '../errors/invalid-email.error';

export class Email {
  private readonly _value: string;
  private static readonly EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  private constructor(value: string) {
    this._value = value;
  }

  public static create(rawEmail: string): Email {
    if (!rawEmail || typeof rawEmail !== 'string') {
      throw new InvalidEmailError(rawEmail);
    }

    const sanitized = rawEmail.trim().toLowerCase();

    if (!Email.EMAIL_REGEX.test(sanitized)) {
      throw new InvalidEmailError(rawEmail);
    }

    return new Email(sanitized);
  }

  public get value(): string {
    return this._value;
  }

  public equals(other: Email): boolean {
    if (!other || !(other instanceof Email)) {
      return false;
    }
    return this._value === other._value;
  }

  public toString(): string {
    return this._value;
  }
}
